export default "__VITE_ASSET__ce0b2e8d__"